module.exports = __webpack_public_path__ + "img/射手座.b243186e.svg";